import Popup from '../Popup';

class FilterPopup extends Popup {
  // eslint-disable-next-line no-useless-constructor
  constructor(el) {
    super(el);
  }

  cacheElements() {
    const popup = this.container.querySelector('.brand-venues__popup-filter');
    const filterOpenerButton = this.container.querySelectorAll('.brand-venues__action-filter');

    return {
      popup,
      showButtons: filterOpenerButton,
      filterOpenerButton: filterOpenerButton[0],
      form: this.container.querySelector('.brand-venues__form'),
      applyButton: this.container.querySelector('.brand-venues__filter-button'),
      inputNumbers: this.container.querySelectorAll('.brand-venues__input-number'),
    };
  }

  init() {
    super.init();

    // Listen for form submit and close popup after filtering
    if (this.elements.form) {
      this.elements.form.addEventListener('submit', (event) => {
        this.toggleButtonAppearance(event.target);

        setTimeout(() => {
          if (this.elements.applyButton) {
            const fakeEvent = new Event('click');
            this.closePopup(fakeEvent, this.elements.applyButton);
          }
        }, 600);
      });

      this.elements.form.addEventListener('reset', () => {
        this.elements.filterOpenerButton.classList.remove('c-button--active');
      });
    }

    if (this.elements.inputNumbers) {
      this.elements.inputNumbers.forEach((input) => {
        input.addEventListener('input', () => {
          // eslint-disable-next-line no-param-reassign
          input.value = Math.abs(input.value) > 0 ? Math.abs(input.value) : '';
        });
      });
    }
  }

  toggleButtonAppearance(form) {
    let hasChanges = false;

    // Check text inputs - consider filled if there is a value
    const textInputs = form.querySelectorAll('input[type="number"]');
    textInputs.forEach((input) => {
      if (input.value && input.value.trim() !== '') {
        hasChanges = true;
      }
    });

    if (!hasChanges) {
      // Check range inputs - consider changed if value is not equal to initial
      const rangeInputs = form.querySelectorAll('input[type="range"]');
      rangeInputs.forEach((input) => {
        const type = input.getAttribute('data-range-type');

        if (
          (type === 'min' && input.getAttribute('min') !== input.value)
          || (type === 'max' && input.getAttribute('max') !== input.value)
        ) {
          hasChanges = true;
        }
      });
    }

    if (!hasChanges) {
      // Check checkboxes - consider changed if at least one is checked
      const checkboxes = form.querySelectorAll('input[type="checkbox"]');
      const checkedBoxes = Array.from(checkboxes).filter((checkbox) => checkbox.checked);
      if (checkedBoxes.length > 0) {
        hasChanges = true;
      }
    }

    // Update button appearance based on changes
    if (hasChanges) {
      this.elements.filterOpenerButton.classList.add('c-button--active');
    } else {
      this.elements.filterOpenerButton.classList.remove('c-button--active');
    }
  }
}

export default FilterPopup;
